import { createBottomTabNavigator } from 'react-navigation-tabs';

import Profile from '../screens/Profile';
import ProfileSettings from '../screens/ProfileSettings';
import ContactScreen from '../screens/Contact';
import Data from '../screens/Data';

const ProfileNavigator = createBottomTabNavigator(
  {
    Profile: {
      screen: Profile,
      navigationOptions: {
        headerShown: false,
        tabBarVisible: false,
      },
    },
    Settings: {
      screen: ProfileSettings,
      navigationOptions: {
        headerShown: false,
        tabBarVisible: false,
      },
    },
    ContactScreen: {
      screen: ContactScreen,
      navigationOptions: {
        headerShown: false,
        tabBarVisible: false,
      },
    },
    Data: {
      screen: Data,
      navigationOptions: {
        headerShown: false,
        tabBarVisible: false,
      },
    },
  },
  {
    initialRouteName: 'Profile',
    tabBarVisible: false,
    // tab: CustomWebNavigation,
    swipeEnabled: false,
    animationEnabled: false,
    gestureEnabled: false,
  },
);

export default ProfileNavigator;
